<template>
  <img
    :class="['hermit_crab', { [tableClass]: from }]"
    :src="$image(`normal/buttons/decoration/hermit_crab-${type}.svg`)"
    alt=""
  />
</template>

<script>
import gsap from 'gsap';
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

const paths = {
  2: [{top: '18%', left: '21%'}, {top: '14%', left: '28%'}],
  3: [{top: '17%', left: '50%'}, {top: '10%', left: '60%'}],
  4: [{top: '22%', left: '80%'}, {top: '22%', left: '88%'}],
  5: [{top: '37%', left: '80%'}, {top: '42%', left: '72%'}],
  6: [{top: '44%', left: '62%'}, {top: '40%', left: '47%'}],
  7: [{top: '53%', left: '30%'}, {top: '56%', left: '26%'}],
  8: [{top: '75%', left: '36%'}, {top: '78%', left: '45%'}],
  9: [{top: '83%', left: '64%'}, {top: '79%', left: '80%'}],
};

export default {
  props: {
    from: {
      type: Number,
      required: false,
    },
    to: {
      type: Number,
      required: false,
    },
    type: {
      type: String,
      default: 'a',
    },
  },
  data() {
    return {
      swayTween: undefined,
    };
  },
  mounted() {
    gsap.registerPlugin(MotionPathPlugin);

    const type = this.type.toUpperCase();

    this.$eventBus.$on(`play-hermitCrab${type}-sway`, this.sway);
    this.$eventBus.$on(`stop-hermitCrab${type}-sway`, this.stopSway);
    this.$eventBus.$on(`end-hermitCrab${type}-sway`, this.revertSway);
  },
  beforeDestroy() {
    const type = this.type.toUpperCase();

    this.$eventBus.$off(`play-hermitCrab${type}-sway`, this.sway);
    this.$eventBus.$off(`stop-hermitCrab${type}-sway`, this.stopSway);
    this.$eventBus.$off(`end-hermitCrab${type}-sway`, this.revertSway);
  },
  watch: {
    "$store.state.animation.currentPlaying"(playing) {
      const type = this.type.toUpperCase();

      if (!this.isShow()) {
        return;
      }

      if (playing === `CrossBridgeHermitCrab${type}`) {
        this.play();
      } else if (playing === "reachLastIsland") {
        this.playOnCompleteSingle();
      }
    },
  },
  computed: {
    tableClass() {
      return `table${this.from}`;
    },
  },
  methods: {
    isShow() {
      return this.$el.style.display !== "none";
    },
    play() {
      let tl = gsap.timeline({ onComplete: () => {
        this.$store.dispatch("animation/next", `CrossBridgeHermitCrab${this.type.toUpperCase()}`);
      }}).delay(0.5);

      for (let table = this.from; table < this.to; table++) {
        this.move(tl, table);
      }

      this.jump(tl);
    },
    playOnCompleteSingle() {
      let tl = gsap.timeline({
        onStart: () => {
          console.log("play single");
          this.$sound.singleClear().play();
        },
        onComplete: () => {
          this.$store.dispatch("animation/next", "reachLastIsland");
        }
      }).delay(0.5);


      this.jump(tl, {
        delay: 0.5,
        onPlay: () => {
          this.$emit("playSound");
          this.$sound.thatsGrate().play();
        },
      });
    },
    sway() {
      this.swayTween = gsap.fromTo(this.$el,
      {
        rotation: -5,
      },
      {
        rotation: 5,
        duration: 0.8,
        transformOrigin: "center bottom",
        ease: "sine.inOut",
        repeat: -1,
        yoyo: true,
      });
    },
    stopSway() {
      this.swayTween.pause();
    },
    revertSway() {
      this.swayTween?.revert();
    },
    move(timeline, table) {
      return timeline.to(this.$el, {
        motionPath: {
          path: paths[table],
          curviness: 1,
        },
        duration: 5,
        onPlay: () => {
          this.sway();
          this.$sound.iDidIt().play();
        },
        onComplete: () => {
          this.stopSway();
        },
      });
    },
    jump(timeline, options = {}) {
      return timeline.to(this.$el, {
        y: "-100%",
        duration: 0.5,
        repeat: 3,
        yoyo: true,
        ease: "power1.inOut",
        ...options,
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.hermit_crab {
  width: calc(var(--size-base) * 71.48);
  z-index: var(--z-index-screen);

 &[class*="table"] {
    position: absolute;
    transform: translate(-50%, -50%);
  }

  &.table {
    &2 {
      top: 26%;
      left: 14%;
    }
    &3 {
      top: 14%;
      left: 38%;
    }
    &4 {
      top: 12%;
      left: 70%;
    }
    &5 {
      top: 29%;
      left: 87%;
    }
    &6 {
      top: 43%;
      left: 63%;
    }
    &7 {
      top: 42%;
      left: 38%;
    }
    &8 {
      top: 65%;
      left: 28%;
    }
    &9 {
      top: 79%;
      left: 55%;
    }
  }
}
</style>